import { IsInt, IsString, IsNumber, IsArray, IsNotEmpty, IsOptional } from 'class-validator';

class Reward {
    count: number;
    title: string;
}

// Here validate only the necessary fields
export class PaymentObject {
    @IsInt()
    @IsNotEmpty()
    id: number;

    @IsNotEmpty()
    @IsString()
    name: string;

    @IsNotEmpty()
    @IsString()
    currency: string;

    @IsNotEmpty()
    @IsNumber()
    price: number;

    @IsOptional()
    @IsArray()
    guid_receiver?: [number, number];

    pic?: string;

    description?: string;

    // Not sure about necessity
    entry_point?: string;

    // No need to validate the reward
    reward?: Reward[];
}
